<template>
  <svg :width="width" :height="height" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.333 2.66699H2.66634C2.31272 2.66699 1.97358 2.80747 1.72353 3.05752C1.47348 3.30756 1.33301 3.6467 1.33301 4.00033V12.0003C1.33301 12.3539 1.47348 12.6931 1.72353 12.9431C1.97358 13.1932 2.31272 13.3337 2.66634 13.3337H13.333C13.6866 13.3337 14.0258 13.1932 14.2758 12.9431C14.5259 12.6931 14.6663 12.3539 14.6663 12.0003V4.00033C14.6663 3.6467 14.5259 3.30756 14.2758 3.05752C14.0258 2.80747 13.6866 2.66699 13.333 2.66699ZM13.333 7.33366H2.66634V5.33366H13.333V7.33366Z" :fill="iconColor"/>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "iconCard",
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
